<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Role
    </button>

    <a-modal v-model="visible" title="Add a new role">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Add Role</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Role Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input a role name!' }]}]"
          />
        </a-form-item>
        <a-form-item
        label="Slug Name">
          <a-input
            placeholder="Slug name"
            v-decorator="['slug', {rules: [{ required: true, message: 'Please input a role slug!' }]}]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
        </a-form-item>
        <a-form-item label="Role Status">
          <!-- <a-checkbox @change="onChangeStatus" v-decorator="['status']">{{ this.statustext }}</a-checkbox> -->
          <a-checkbox v-model="statuscheckvalue" v-decorator="['status']">{{ this.statustext }}</a-checkbox>
        </a-form-item>
        <permission-element :data="permissiondata" @onRoleCheck="getrole"></permission-element>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import PermissionElement from '@/components/role/comps/permission'

export default {
  name: 'AddRole',
  components: { PermissionElement },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      statustext: 'Not Active',
      permissiondata: [],
      selectedrole: [],
      statuscheckvalue: true,
      statusvalue: 1,
    }
  },
  watch: {
    statuscheckvalue(n, o) {
      this.statusvalue = n ? 1 : 0
    },
  },
  mounted: function () {
    this.$http.get('/api/permission')
      .then((data) => {
        this.permissiondata = data.data.data
        console.dir(data)
        console.log(data.data.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  methods: {
    getrole: function (v) {
      this.selectedrole = v
      console.log(this.selectedrole)
    },
    showModal() {
      this.visible = true
    },
    onChangeStatus(e) {
      if (e.target.checked) {
        this.statustext = 'Active'
      } else {
        this.statustext = 'Not Active'
      }
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('values....')
        console.log(values)
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the role!`,
            // onOk: () => {
            //   const rdata = Object.assign(values, { status: this.statusvalue, permissions: this.selectedrole })
            //   console.log('post data', values)
            // },
            onOk: () => {
              const rdata = Object.assign(values, { status: this.statusvalue, permissions: this.selectedrole })
              this.$http
                // .post('/api/school-role', {
                //   name: values.name,
                //   description: values.description,
                //   slug: values.slug,
                //   status: values.status ? '1' : '0',
                //   // permissions: values.permissions,
                //   permissions: this.selectedrole, // [1,23,5] // !TODO get it from actual permission data..!BARIS!
                // })
                .post('/api/school-role', rdata)
                .then((data) => {
                  // console.log(`logging ... \n${data}`) // Remove this!!
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Role successfully added',
                    description: `Role ${values.name} added successfully!`,
                  })
                  this.form.resetFields()
                  // reseting fields
                  this.statusvalue = true
                  this.selectedrole = []
                })
                .catch(error => {
                  console.log('reaching error')
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
